<template>
  <div class="icon-group">
    <div class="share-box facebook-purple-box">
      <a
        class="facebook-purple"
        href="https://www.facebook.com/shanghaieyeSMG"
        target="_blank"
      ></a>
    </div>
    <div class="share-box x-purple-box">
      <a class="x-purple" href="https://twitter.com/ShanghaiEye" target="_blank"></a>
    </div>
    <div class="share-box youtube-purple-box">
      <a
        class="youtube-purple"
        href="https://www.youtube.com/channel/UCaxIsKnhxr6bfaJFQc67-rg"
        target="_blank"
      ></a>
    </div>
    <div class="share-box unknown-purple-box">
      <!-- <a
        class="unknown-purple"
        href="https://www.instagram.com/shanghaieye/?hl=zh-cn"
        target="_blank"
      ></a> -->
      <a
        class="unknown-purple"
        href="https://instagram.com/shanghaieye?igshid=OGQ5ZDc2ODk2ZA=="
        target="_blank"
      ></a>
    </div>
    <div class="share-box tiktok-purple-box" style="padding: 7.5px 8px">
      <a
        class="tiktok-purple"
        href="https://www.tiktok.com/@shanghaieye?lang=en"
        target="_blank"
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "IconGroup",
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .icon-group {
    // margin-left: 25px;
    margin-top: 10px;
    height: 50px;
    width: 100%;
    // float: left;
    display: flex;
    justify-content: center;
    .share-box {
      height: 35px;
      width: 35px;
      float: left;
      padding: 8px;
      border: 1px solid #c6c5c5;
      margin: 0 8px;
    }
    a {
      width: 100%;
      height: 100%;
      cursor: pointer;
      float: left;
    }
  }
}
@media screen and (min-width: 768px) {
  .icon-group {
    margin-top: 10px;
    height: 50px;
    width: 100%;
    // float: left;
    display: flex;
    justify-content: center;
    .share-box {
      height: 35px;
      width: 35px;
      float: left;
      padding: 10px;
      border: 1px solid #c6c5c5;
      margin: 0 8px;
    }
    a {
      width: 100%;
      height: 100%;
      cursor: pointer;
      float: left;
    }
  }
}

.icon-group {
  width: 100%;
  .facebook-purple-box {
    &:hover {
      border-color: #2479ee;
      a {
        background: url("~@/assets/imgs/layout/facebook_logo.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    a {
      background: url("~@/assets/imgs/layout/facebook_purple.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .x-purple-box {
    &:hover {
      border-color: #343435;
      a {
        background: url("~@/assets/imgs/layout/x_logo.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    a {
      background: url("~@/assets/imgs/layout/x_purple.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .youtube-purple-box {
    &:hover {
      border-color: #ff0000;
      a {
        background: url("~@/assets/imgs/layout/youtube_logo.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    a {
      background: url("~@/assets/imgs/layout/youtube_purple.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .unknown-purple-box {
    &:hover {
      border-color: #e1147e;
      a {
        background: url("~@/assets/imgs/layout/unknown_logo.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    a {
      background: url("~@/assets/imgs/layout/unknown_purple.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .tiktok-purple-box {
    &:hover {
      border-color: #000000;
      a {
        background: url("~@/assets/imgs/layout/tiktok_logo.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    a {
      background: url("~@/assets/imgs/layout/tiktok_purple.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .facebook {
    background: url("~@/assets/imgs/layout/facebook-g.png") no-repeat;
    background-size: 100% 100%;
  }
  .facebook:hover {
    background: url("~@/assets/imgs/layout/facebook.png") no-repeat;
    background-size: 100% 100%;
  }
  .tuite {
    background: url("~@/assets/imgs/layout/tuite-g.png") no-repeat;
    background-size: 100% 100%;
  }
  .tuite:hover {
    background: url("~@/assets/imgs/layout/tuite.png") no-repeat;
    background-size: 100% 100%;
  }
  .youtube {
    background: url("~@/assets/imgs/layout/youtube-g.png") no-repeat;
    background-size: 100% 100%;
  }
  .youtube:hover {
    background: url("~@/assets/imgs/layout/youtube.png") no-repeat;
    background-size: 100% 100%;
  }
  .tuite {
    background: url("~@/assets/imgs/layout/tuite-g.png") no-repeat;
    background-size: 100% 100%;
  }
  .tuite:hover {
    background: url("~@/assets/imgs/layout/tuite.png") no-repeat;
    background-size: 100% 100%;
  }
  .unknown {
    background: url("~@/assets/imgs/layout/unknown-g.png") no-repeat;
    background-size: 100% 100%;
  }
  .unknown:hover {
    background: url("~@/assets/imgs/layout/unknown.png") no-repeat;
    background-size: 100% 100%;
  }
  .music {
    background: url("~@/assets/imgs/layout/douyin_b.png") no-repeat;
    background-size: 100% 100%;
  }
  .music:hover {
    background: url("~@/assets/imgs/layout/douyin_h.png") no-repeat;
    background-size: 100% 100%;
  }
  .sina {
    background: url("~@/assets/imgs/layout/xinlang-g.png") no-repeat;
    background-size: 100% 100%;
  }
  .sina:hover {
    background: url("~@/assets/imgs/layout/xinlang.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
